import { render, staticRenderFns } from "./PainelJornada2021.vue?vue&type=template&id=bcd0e5f0"
import script from "./PainelJornada2021.vue?vue&type=script&lang=js"
export * from "./PainelJornada2021.vue?vue&type=script&lang=js"
import style0 from "./PainelJornada2021.vue?vue&type=style&index=0&id=bcd0e5f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports